module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-05.2ea82b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-05.jpg
// module id = pusP
// module chunks = 52